export const CONDITIONS_ROUTE = {
  name: 'Conditions',
  path: 'conditions',
};
